import {


  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,


  VERIFY_FORGET_PASSWORD,
  VERIFY_FORGET_PASSWORD_SUCCESS,
  VERIFY_FORGET_PASSWORD_FAIL,


  RESEND_FORGET_PASSWORD_CODE,
  RESEND_FORGET_PASSWORD_CODE_SUCCESS,
  RESEND_FORGET_PASSWORD_CODE_FAIL,


} from "./actionTypes"

export const forgetPassword = (account) => {
  return {
    type: FORGET_PASSWORD,
    payload: account ,
  }
}

export const forgetPasswordSuccess = response => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: response,
  }
}

export const forgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}

// VERIFY FORGET PASSWORD
export const verifyForgetPassword = code => ({
  type: VERIFY_FORGET_PASSWORD,
  payload: code,
})

export const verifyForgetPasswordSuccess = response => ({
  type: VERIFY_FORGET_PASSWORD_SUCCESS,
  payload: response,
})

export const verifyForgetPasswordFail = error => ({
  type: VERIFY_FORGET_PASSWORD_FAIL,
  payload: error,
})

// RESEND FORGET PASSWORD CODE
export const resendForgetPasswordCode = (token) => ({
    type: RESEND_FORGET_PASSWORD_CODE,
    payload: { token }
});

export const resendForgetPasswordCodeSuccess = (token) => ({
    type: RESEND_FORGET_PASSWORD_CODE_SUCCESS,
    payload: { token }
});

export const resendForgetPasswordCodeFail = (error) => ({
    type: RESEND_FORGET_PASSWORD_CODE_FAIL,
    payload: error,
});
